export const SELECT_STYLES = {
  trigger: [
    'bg-white',
    'border',
    'border-gray-300',
    'hover:border-violet-400',
    'focus:border-violet-400',
    'data-[hover=true]:border-violet-400',
    'data-[open=true]:border-violet-400',
    'data-[focus=true]:border-violet-400',
    '!cursor-pointer',
    '!rounded-xl',
    'text-gray-800',
    'data-[hover=true]:bg-violet-50',
    'min-h-[44px]',
    'h-[44px]',
    'flex',
    'items-center',
    'pl-10',
    'pr-3',
    'relative',
    'shadow-sm',
    'hover:shadow-md',
    'transition-all',
    'duration-200',
  ],
  value: ['text-gray-800', 'font-normal', 'flex-1', 'text-left'],
  selectorIcon: [
    'text-gray-400',
    'w-5',
    'h-5',
    'flex-shrink-0',
    'absolute',
    'left-3',
    'top-1/2',
    '-translate-y-1/2',
  ],
  popoverContent: ['bg-white', 'border', 'border-gray-200', 'rounded-xl', '!w-full', 'min-w-full', 'shadow-xl'],
  base: ['!p-0', '!m-0'],
  mainWrapper: ['!h-[44px]'],
  innerWrapper: ['!h-full', 'flex', 'items-center', 'justify-between', 'px-0'],
};

export const OPTION_STYLES = {
  default:
    'text-gray-800 data-[hover=true]:bg-violet-50 data-[hover=true]:rounded-lg data-[selected=true]:bg-gradient-to-r data-[selected=true]:from-violet-100 data-[selected=true]:to-purple-100 data-[selected=true]:rounded-lg',
  loader: 'text-gray-600 hover:bg-transparent cursor-default',
};

export const DEFAULT_LOAD_MORE_THRESHOLD = 2;
export const DEFAULT_ROOT_MARGIN = '100px';
export const LOADER_KEY = '__loader__';
